module.exports = __webpack_public_path__ + "static/media/achievement-walk-run-ride.2f3d99c3.svg";